<template>
  <transition name="el-fade-in">
    <div v-show="visible" class="header-fixed">
      <div class="container">
        <el-row align="middle" justify="space-between" type="flex">
          <el-col :lg="4" :xl="4">
            <a class="nav-logo-content" href="#">
              <img
                alt="logo"
                class="logo-image"
                :src="logoData.image"
              />
              <div class="logo-text-wrapper" v-if="logoData.title">
                <span v-for="(item, i) in logoData.title.split(' ')" :key="i">{{
                  item
                }}</span>
              </div>
            </a>
          </el-col>
          <el-col :lg="7" :xl="7">
            <p class="count-objects">
              <span class="count">{{ pagination.total }}</span
              ><span class="count-block-none">знайдено обєктів</span>
              <span class="count-block-block">обєктів</span>
            </p>
          </el-col>
          <el-col :lg="6" :xl="6">
            <div class="select-sort">
              <span class="sort-title">Cортування: </span>
              <el-select :value="sort" @change="sortHandler">
                <el-option
                  v-for="item in sorting"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                  >{{ item.title }}
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :lg="5" :xl="5">
            <button
              :class="{ active: isFlatFilterUsed }"
              :disabled="!isFlatFilterUsed"
              class="filter-button rounded-btn"
              @click="showFilterRemoveList = !showFilterRemoveList"
            >
              <div class="circle">
                <IconBase height="16" width="16">
                  <FilterIcon />
                </IconBase>
              </div>
              <span
                class="selected-text"
                :style="isFlatFilterUsed ? 'color:white' : ''"
                ><span v-if="isFlatFilterUsed">Показати</span>
                <span v-else>Застосований</span> фільтр</span
              >
            </button>
          </el-col>
          <el-col :lg="1" :xl="1">
            <button
              @click="goToFavorite"
              class="rounded-btn blue selected-link"
            >
              <span class="heart-icon">
                <IconBase height="16" width="16"><Heart /></IconBase>
              </span>
              <span class="selected-counter">{{ favoriteFlats.length }}</span>
            </button>
          </el-col>
          <el-col :lg="1" :xl="1">
            <button
              class="rounded-btn blue add-new-object"
              type="button"
              @click="goToAdvert"
            >
              <IconBase height="10" width="11">
                <Plus />
              </IconBase>
            </button>
          </el-col>
        </el-row>
        <el-collapse-transition>
          <div v-show="showFilterRemoveList" class="filter-controls">
            <div class="filter-remove-list" v-if="flatParams">
              <!--ROOMS              -->
              <button
                v-for="(item, index) in Object.entries(flatFilter.rooms)"
                v-if="item[1]"
                :key="item[0] + index"
                @click="
                  filterHandler({
                    rooms: { ...flatFilter.rooms, [item[0]]: false },
                  })
                "
                class="transparent-btn"
                type="button"
              >
                {{ flatParams.rooms[item[0]] }} к <span>&times;</span>
              </button>

              <!-- TYPE REALTY              -->
              <button
                v-for="(item, index) in flatFilter.type_realty"
                :key="item + 'type_realty'"
                @click="
                  filterHandler({
                    type_realty: flatFilter.type_realty.filter(
                      (el) => el !== item
                    ),
                  })
                "
                class="transparent-btn"
                type="button"
              >
                {{ flatParams.type_realties.find((el) => el.id === item).name }}
                <span>&times;</span>
              </button>

              <!--DISTRICTS              -->
              <button
                v-for="(item, index) in flatFilter.districts"
                :key="item + 'district'"
                class="transparent-btn"
                type="button"
                @click="
                  filterHandler({
                    districts: flatFilter.districts.filter((el) => el !== item),
                  })
                "
              >
                {{
                  flatParams.districts.find((district) => item === district.id)
                    .name
                }}
                <span>&times;</span>
              </button>

              <!--PRICE              -->
              <button
                class="transparent-btn"
                type="button"
                v-if="
                  flatFilter.price.start !== defaultFlatsFilter.price.start ||
                  flatFilter.price.end !== defaultFlatsFilter.price.end
                "
                @click="
                  filterHandler({
                    price: {
                      start: defaultFlatsFilter.price.start,
                      end: defaultFlatsFilter.price.end,
                    },
                  })
                "
              >
                {{ flatFilter.price.start }} - {{ flatFilter.price.end }}
                {{ currency === 'usd' ? '$' : '₴' }}

                <span>&times;</span>
              </button>

              <!-- FLOOR              -->
              <button
                v-for="(item, index) in Object.entries(flatFilter.floor)"
                v-if="item[1]"
                :key="item[0] + 'floor'"
                @click="
                  filterHandler({
                    floor: { ...flatFilter.floor, [item[0]]: false },
                  })
                "
                class="transparent-btn"
                type="button"
              >
                {{ flatParams.floor[item[0]] }} <span>&times;</span>
              </button>

              <!--STATES              -->
              <button
                v-for="(item, index) in flatFilter.states"
                :key="item + 'state'"
                @click="
                  filterHandler({
                    states: flatFilter.states.filter((el) => el !== item),
                  })
                "
                class="transparent-btn"
                type="button"
              >
                {{ flatParams.states.find((elem) => item === elem.id).name }}
                <span>&times;</span>
              </button>

              <!--PLANNINGS              -->
              <button
                v-for="(item, index) in flatFilter.plannings"
                :key="item + 'planning'"
                @click="
                  filterHandler({
                    plannings: flatFilter.plannings.filter((item) => !item),
                  })
                "
                class="transparent-btn"
                type="button"
              >
                {{ flatParams.plannings.find((elem) => item === elem.id).name }}
                <span>&times;</span>
              </button>

              <!-- Material              -->
              <button
                v-for="(item, index) in Object.entries(flatFilter.material)"
                v-if="item[1]"
                :key="item[0] + 'material'"
                @click="
                  filterHandler({
                    material: { ...flatFilter.material, [item[0]]: false },
                  })
                "
                class="transparent-btn"
                type="button"
              >
                {{ flatParams.material[item[0]] }} <span>&times;</span>
              </button>

              <!--AREA              -->
              <button
                class="transparent-btn"
                type="button"
                v-if="
                  flatFilter.area.start !== flatParams.area.start ||
                  flatFilter.area.end !== flatParams.area.end
                "
                @click="
                  filterHandler({
                    area: {
                      start: flatParams.area.start,
                      end: flatParams.area.end,
                    },
                  })
                "
              >
                {{ flatFilter.area.start }} - {{ flatFilter.area.end }}м<sup
                  >2</sup
                >
                <span>&times;</span>
              </button>
            </div>
            <div class="action-buttons">
              <a
                v-smooth-scroll
                class="transparent-btn"
                href="#filter-scroll-to"
                @click="
                  showFilterRemoveList = false
                  resetFlatFilter()
                "
              >
                Очистити фільтр
                <img alt="reset" src="../../assets/images/reset.png" />
              </a>
              <a
                v-smooth-scroll
                class="transparent-btn"
                href="#filter-scroll-to"
                type="button"
              >
                Перейти до основного фільтру
                <img
                  alt="arrow"
                  class="rotate-right"
                  src="../../assets/images/arrow.png"
                />
              </a>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
  </transition>
</template>

<script>
import IconBase from '@/components/icons/IconBase'
import Heart from '@/components/icons/Heart'
import Plus from '@/components/icons/Plus'
import FilterIcon from '@/components/icons/FilterIcon'
import { SORTING_LIST } from '@/helper/emptyFilters'
import { mapGetters } from 'vuex'
import { host } from '@/services/config'

export default {
  name: 'Header_Fixed',
  components: { FilterIcon, Plus, Heart, IconBase },
  mounted() {
    const sortBlock = document.querySelector('.sorting-part')
    sortBlock.offsetTop < window.scrollY
      ? (this.visible = true)
      : (this.visible = false)
    window.addEventListener('scroll', (event) => {
      sortBlock.offsetTop < window.scrollY
        ? (this.visible = true)
        : (this.visible = false)
    })
  },
  computed: {
    ...mapGetters({
      flatParams: 'getFlatsFilterParams',
      flatFilter: 'getFlatsFilter',
      defaultFlatsFilter: 'getDefaultFlatsFilter',
      isFlatFilterUsed: 'isFlatFilterUsed',
      sort: 'getFlatsSorting',
      pagination: 'getFlatsPagination',
      currency: 'getGlobalCurrency',
      usdCourse: 'getUsdCourse',
      favoriteFlats: 'getFavoriteFlatList',
      logoData: 'getLogoData',
    }),
  },
  watch: {
    isFlatFilterUsed(newValue) {
      if (!newValue) this.showFilterRemoveList = false
    },
  },
  data() {
    return {
      visible: false,
      showFilterRemoveList: false,
      value: 1,
      sorting: SORTING_LIST,
      baseURL: host,
    }
  },
  methods: {
    sortHandler(event) {
      this.$store.dispatch('changeFlatsSorting', event)
    },
    goToFavorite() {
      this.$router.push({ name: 'favorite' })
    },
    goToAdvert() {
      this.$router.push('/add-advertisement')
    },
    resetFlatFilter() {
      //reset all filter filter. null parameter is required
      this.$store.dispatch('changeFlatsFilter', null)
    },
    filterHandler(value) {
      this.$store.dispatch('changeFlatsFilter', {
        ...this.flatFilter,
        ...value,
      })
    },
  },
}
</script>

<style scoped></style>
